/* ===== main.js ===== */
/* 下鴨茶寮の贈りもの LP
   0. スクロール連動のフェードイン（下の fade）
   1. 画面下に固定するボタン: ファーストビューを通り過ぎてから表示（ユーザー指示。おせち2027 と同じ挙動）
      判定は IntersectionObserver ＋ scroll/resize の保険。要素に .is-managed を付け、表示中は .is-visible。
*/
(function () {
  'use strict';

  /* ---- スクロール連動のフェードイン（2026-11-02 依頼者の指示。おせち2027・はりはりと同じ。Figma に無い演出） ----
     - 各 section 直下（PC は .inner 直下）の要素に .lp-fade を付け、画面に入ったら .lp-visible を付ける
     - 同じ section 内では順番に 0.08s ずつ遅らせる（上限 0.48s）
     - ファーストビュー（.fv）と、prefers-reduced-motion の環境では何もしない。IntersectionObserver が無ければ最初から表示
       （検証用スクリーンショットは Edge/Chrome に --force-prefers-reduced-motion を付けると演出なしで撮れる） */
  (function fade() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('.gift-lp .lp-main section:not(.fv)');
    var targets = [];
    Array.prototype.forEach.call(sections, function (section) {
      var box = section.querySelector(':scope > .inner') || section;
      var i = 0;
      Array.prototype.forEach.call(box.children, function (el) {
        el.classList.add('lp-fade');
        el.style.transitionDelay = (Math.min(i, 6) * 0.08) + 's';
        targets.push(el);
        i += 1;
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('lp-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  })();

  (function stickyCta() {
    var bars = document.querySelectorAll('.sticky-cta');
    var fvs = document.querySelectorAll('.fv');
    if (!bars.length || !fvs.length) return;

    Array.prototype.forEach.call(bars, function (bar) { bar.classList.add('is-managed'); });

    function passedFv(fv) {
      if (fv.offsetParent === null) return false;   /* display:none のもの */
      return fv.getBoundingClientRect().bottom <= 0;
    }

    function update() {
      var passed = Array.prototype.some.call(fvs, passedFv);
      Array.prototype.forEach.call(bars, function (bar) { bar.classList.toggle('is-visible', passed); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function () { update(); }, { threshold: [0, 0.01] });
      Array.prototype.forEach.call(fvs, function (fv) { io.observe(fv); });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();
})();
